import { extendZodWithOpenApi } from "@asteasolutions/zod-to-openapi/dist/zod-extensions";
import { z } from "zod";

extendZodWithOpenApi(z);

export const registerQuerySchema = z.object({
  id: z.string().openapi({
    description: "User ID",
  }),
});

export type RegisterQuery = z.infer<typeof registerQuerySchema>;

export const registerRequestSchema = z.object({
  query: registerQuerySchema,
});

export type RegisterRequest = z.infer<typeof registerRequestSchema>;

export const registerResponseSchema = z.string().openapi({
  description: "Redirect URL",
});

export type RegisterResponse = z.infer<typeof registerResponseSchema>;
